import { useTranslations } from 'next-intl'

import { Link } from '@/shared/i18n'
import { Button } from '@/shared/ui'

import NoSearchResult from '../../asset/no-search-result.svg'

export const NonVisibleRoomPage = () => {
  const t = useTranslations('room_empty')

  return (
    <div className="flex h-[calc(100vh-72px)] flex-col items-center bg-gray-50 pt-30">
      <NoSearchResult className="mb-6 block" />
      <h2 className="typo-headline2 mb-4 font-bold text-black">{t('title')}</h2>
      <p className="typo-body1 mb-10 text-center font-normal whitespace-break-spaces text-gray-900">
        {t('description')}
      </p>
      <Button
        asChild
        variant="solid"
        color="primary"
        size="large"
        className="w-60"
      >
        <Link href="/">{t('button')}</Link>
      </Button>
    </div>
  )
}
